import { render, staticRenderFns } from "./ComentarioAsesor.vue?vue&type=template&id=4a6483ba&scoped=true&"
import script from "./ComentarioAsesor.vue?vue&type=script&lang=js&"
export * from "./ComentarioAsesor.vue?vue&type=script&lang=js&"
import style0 from "./ComentarioAsesor.vue?vue&type=style&index=0&id=4a6483ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6483ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VContainer,VDivider,VIcon,VList,VListItem,VListItemContent,VSpacer,VToolbar,VToolbarTitle})
